<template>
  <div class="betalog">
    <!-- Header -->
    <div class="header">
      <h4>Notities</h4>
      <div class="close-btn" @click="$emit('close-modal')">
        <img src="../../assets/close-btn.png" />
      </div>
    </div>

    <!-- Body -->
    <div class="body">
      <!-- Nieuwe todo toevoegen -->
      <div class="newtodo">
        <input type="text" class="nieuwitemfield" placeholder="Nieuw item" v-model="nieuweTodo.todo" />
        <input type="checkbox" class="check" v-model="nieuweTodo.belangrijk" />
        <button class="button" @click="voegTodoToe(nieuweTodo)">Voeg toe</button>
      </div>

      <!-- Belangrijke todos -->
      <ul class="belangrijk-list">
        <li v-for="todo in orderBy(alleBelangrijkeTodos, 'id')" :key="todo.id">
          <TodoItem :todo="todo" />
        </li>
      </ul>

      <!-- Normale todos -->
      <ul>
        <li v-for="todo in orderBy(alleNormaleTodos, 'id')" :key="todo.id">
          <TodoItem :todo="todo" />
        </li>
      </ul>

      <div class="afgerond">
        <div class="headerbar" @click="toonafgerond = !toonafgerond">
          <span>Afgeronde items ({{ alleAfgerondeTodos.length }})</span>
          <div class="toggleknop">
            <div v-if="!toonafgerond"><span>Toon </span> <span style="font-size: 11px">▼</span></div>
            <div v-if="toonafgerond"><span>Verberg </span> <span style="font-size: 11px">▲</span></div>
          </div>
        </div>
        <ul v-if="toonafgerond">
          <li v-for="todo in orderBy(alleAfgerondeTodos, 'id')" :key="todo.id">
            <TodoItem :todo="todo" />
          </li>
        </ul>
      </div>

      <!-- Afgeronde todos -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { mapActions } from 'vuex';
import Vue2Filters from 'vue2-filters';

import TodoItem from './BetaTodoItem';

export default {
  name: 'BetaModal',
  components: { TodoItem },
  mixins: [Vue2Filters.mixin],
  data() {
    return {
      toonafgerond: false,
      nieuweTodo: {
        todo: '',
        belangrijk: false
      }
    };
  },
  computed: {
    ...mapGetters(['alleBelangrijkeTodos', 'alleNormaleTodos', 'alleAfgerondeTodos'])
  },
  methods: {
    ...mapActions(['voegTodoToe'])
  }
};
</script>

<style scoped>
.nieuwitemfield {
  padding: 10px;
  border-radius: 6px;
  -webkit-appearance: none;
  width: 70%;
}
button {
  color: #fff;
  width: 25%;
  border: 1px solid #0475f2;
  border-radius: 5px;
  padding: 8px 11px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  background-color: #0475f2;
}
.betalog {
  background-color: white;
  border-radius: 6px;
  overflow: hidden;
  position: fixed;
  left: 110px;
  bottom: 10px;
  z-index: 10;
  box-shadow: -20px 0 100px 0 rgba(0, 0, 0, 0.21);
}
.header {
  background-color: #1b4d8d;
  padding: 20px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  color: white;
}
.close-btn {
  width: 24px;
  height: 24px;
  display: flex;
  cursor: pointer;
  transition: 0.3s;
}
.close-btn:hover {
  transform: scale(1.2);
}

.body {
  padding: 30px 40px;
}
ul {
  padding: 20px 0;
}
.belangrijk-list {
  color: orange;
  border-bottom: 1px solid lightgray;
}

.afgerond .headerbar {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  flex-direction: row;
  width: 100%;
  padding: 10px;
  border-radius: 6px;
  cursor: pointer;
}
.headerbar:hover {
  background-color: #f8f8f8;
}

.afgerond {
  width: 100%;
  background-color: #f1f1f1;
  border-radius: 6px;
}
.afgerond ul {
  padding: 10px;
}
</style>
